import { makeStyles } from 'tss-react/mui';

const backgroundAnimationKeyframes = {
  '@keyframes lightning': {
    '0%': {
      opacity: 0.4,
    },
    '9.5%': {
      background: '#000',
      opacity: 0.1,
    },
    '10%': {
      background: '#FFFFFF67',
      opacity: 0.3,
    },
    '19.8%': {
      background: '#000',
      opacity: 0.1,
    },
    '20%': {
      background: '#FFFFFF67',
      opacity: 0.2,
    },
    '35%': {
      background: '#000',
      opacity: 0.1,
    },
    '49.8%': {
      background: '#000',
      opacity: 0.1,
    },
    '50%': {
      background: '#FFFFFF67',
      opacity: 0.3,
    },
    '80%': {
      background: '#000',
      opacity: 0.1,
    },
  },
};
const useStyles = makeStyles()(() => ({
  lightning: {
    position: 'absolute',
    inset: 0,
    pointerEvents: 'none',
    overflow: 'hidden',
    height: 'auto',
    width: 'auto',
    background: '#000',
    opacity: 0.1,
    animationDuration: '4s',
    animationDelay: '2.5s',
    animationIterationCount: '4',
    animationName: 'lightning',
    ...backgroundAnimationKeyframes,
  },
}));

const Lightning = () => {
  const { classes } = useStyles();

  return <div className={classes.lightning}></div>;
};

export default Lightning;
